export const countryOptions = [
    { value: "", label: "All Countries" },
    { value: "usa", label: "United States" },
    { value: "gbr", label: "United Kingdom" },
    { value: "can", label: "Canada" },
    { value: "aus", label: "Australia" },
    { value: "deu", label: "Germany" },
    { value: "fra", label: "France" },
    { value: "esp", label: "Spain" },
    { value: "ita", label: "Italy" },
    { value: "jpn", label: "Japan" },
    { value: "ind", label: "India" },
    { value: "bra", label: "Brazil" },
    { value: "mex", label: "Mexico" },
    { value: "nld", label: "Netherlands" },
    { value: "swe", label: "Sweden" },
    { value: "nor", label: "Norway" },
    { value: "dnk", label: "Denmark" },
    { value: "fin", label: "Finland" },
  ]; 